import { render } from "./MasterOrders.vue?vue&type=template&id=04de5266&scoped=true"
import script from "./MasterOrders.vue?vue&type=script&lang=js"
export * from "./MasterOrders.vue?vue&type=script&lang=js"

import "./MasterOrders.vue?vue&type=style&index=0&id=04de5266&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04de5266"]])

export default __exports__